export default class NetworkError extends Error {
    constructor(
        message: string,
        public originalError?: unknown,
    ) {
        super(message);
        this.name = 'NetworkError';
    }
}
